/* Mambobaby sticky add-to-cart bar — syncs with Dawn's product form */
if (!customElements.get('mambo-sticky-atc')) {
  customElements.define(
    'mambo-sticky-atc',
    class MamboStickyAtc extends HTMLElement {
      connectedCallback() {
        // move to <body> so position:fixed is not trapped by animated/transformed ancestors
        if (this.parentElement !== document.body) {
          // if a bar already lives in <body> (re-rendered product form), drop this duplicate
          const existing = document.querySelector('body > mambo-sticky-atc');
          if (existing && existing !== this) {
            this.remove();
            return;
          }
          document.body.appendChild(this);
          return;
        }
        if (this.initialised) return;
        this.initialised = true;
        this.main = document.querySelector('[id^="MainProduct-"]');
        if (!this.main) return;
        this.mainButton = this.main.querySelector('.product-form__submit');
        this.mainPrice = this.main.querySelector('[id^="price-"]');
        this.button = this.querySelector('[data-sticky-submit]');
        this.buttonText = this.querySelector('[data-sticky-submit-text]');
        this.price = this.querySelector('[data-sticky-price]');
        this.image = this.querySelector('[data-sticky-image]');
        this.variantEl = this.querySelector('[data-sticky-variant]');
        if (!this.mainButton || !this.button) return;

        // variant dropdown inside the bar drives the real variant picker
        this.select = this.querySelector('[data-sticky-variant-select]');
        if (this.select) {
          this.select.addEventListener('change', () => this.selectVariant(this.select.selectedOptions[0]));
        }

        this.button.addEventListener('click', () => {
          const btn = this.main.querySelector('.product-form__submit');
          if (btn && !btn.disabled) btn.click();
        });

        // visibility: show once the main button has scrolled above the viewport, hide near the footer
        this.footer = document.querySelector('.footer');
        this.onScroll = () => {
          if (this.tick) return;
          this.tick = setTimeout(() => {
            this.tick = null;
            const vh = document.documentElement.clientHeight || window.innerHeight || 0;
            const btn = this.main.querySelector('.product-form__submit') || this.mainButton;
            if (!btn) return;
            const rect = btn.getBoundingClientRect();
            const passed = rect.bottom < 0;
            let footerVisible = false;
            if (this.footer && vh) footerVisible = this.footer.getBoundingClientRect().top < vh;
            this.toggle(passed && !footerVisible);
          }, 80);
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.onScroll();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            setTimeout(() => this.sync(event && event.data ? event.data.variant : null), 50);
          });
        }
        this.sync(null);
      }

      disconnectedCallback() {
        if (this.onScroll) {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
        }
        if (this.unsubscribe) this.unsubscribe();
      }

      toggle(show) {
        const visible = !!show;
        this.classList.toggle('is-visible', visible);
        this.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }

      selectVariant(option) {
        if (!option) return;
        let values = [];
        try {
          values = JSON.parse(option.dataset.options || '[]');
        } catch (e) {
          return;
        }
        const picker = this.main.querySelector('variant-selects');
        if (!picker) return;
        let lastChanged = null;
        values.forEach((value, index) => {
          const position = index + 1;
          const radio = Array.from(picker.querySelectorAll('input[type="radio"]')).find(
            (input) => input.name.trim().endsWith('-' + position) && input.value.trim() === value
          );
          if (radio) {
            if (!radio.checked) {
              radio.checked = true;
              lastChanged = radio;
            }
            return;
          }
          const select = Array.from(picker.querySelectorAll('select')).find((sel) =>
            Array.from(sel.options).some((o) => o.value === value)
          );
          if (select && select.value !== value) {
            select.value = value;
            lastChanged = select;
          }
        });
        if (lastChanged) {
          lastChanged.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      sync(variant) {
        // the main button may have been re-rendered by Dawn: re-query
        this.mainButton = this.main.querySelector('.product-form__submit') || this.mainButton;
        this.mainPrice = this.main.querySelector('[id^="price-"]') || this.mainPrice;

        // price: copy the visible sale/regular price text from the main price block
        if (this.mainPrice && this.price) {
          const sale = this.mainPrice.querySelector('.price__sale .price-item--sale');
          const regular = this.mainPrice.querySelector('.price__regular .price-item--regular');
          const isSale = this.mainPrice.querySelector('.price--on-sale');
          const src = isSale && sale ? sale : regular || sale;
          if (src) this.price.textContent = src.textContent.trim();
        }

        // availability + label from the main button
        if (this.mainButton && this.button) {
          const disabled = this.mainButton.disabled || this.mainButton.classList.contains('disabled');
          this.button.disabled = disabled;
          const label = this.mainButton.querySelector('span');
          if (label && this.buttonText) this.buttonText.textContent = label.textContent.trim();
        }

        if (variant) {
          if (this.variantEl && variant.title && variant.title !== 'Default Title') {
            this.variantEl.textContent = variant.title;
          }
          if (this.select && variant.id && String(this.select.value) !== String(variant.id)) {
            this.select.value = String(variant.id);
          }
          const img = variant.featured_image || (variant.featured_media && variant.featured_media.preview_image);
          if (img && img.src && this.image) {
            const base = img.src.split('?')[0];
            this.image.src = base + '?width=160';
            this.image.srcset = base + '?width=80 80w, ' + base + '?width=160 160w';
          }
        }
      }
    }
  );
}
